module.exports = __webpack_public_path__ + "static/assets/6d00bc8c73439af5164a36b66f0c54db.png";